import { render, staticRenderFns } from "./electronic.vue?vue&type=template&id=12b4ccd4&scoped=true&"
import script from "./electronic.vue?vue&type=script&lang=js&"
export * from "./electronic.vue?vue&type=script&lang=js&"
import style0 from "./electronic.vue?vue&type=style&index=0&id=12b4ccd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4ccd4",
  null
  
)

export default component.exports